import { GatsbyImage } from "gatsby-plugin-image"
import React from "react"

import ContactForm from "./forms/Contact"
import RichText from "./richText/Parser"

const addForm = type => {
  switch (type) {
    case "contact":
      return <ContactForm formId="contact-form"/>
    default:
      return <br />
  }
}
export default function Contact({ component }) {
  return (
    <div className="relative bg-white">
      <div className="relative sm:absolute sm:inset-0">
        <div className="sm:absolute sm:inset-y-0 sm:left-0 w-full sm:w-1/3 lg:w-1/2 bg-white ">
          <GatsbyImage
            image={
              component.sideImage?.localFile?.childImageSharp?.gatsbyImageData
            }
            alt={component.sideImage?.alt || ``}
            className="h-64 w-full object-center	 object-cover sm:absolute sm:h-full"
          />
        </div>
      </div>
      <div className="relative pt-8 pb-16 sm:py-16 px-4 sm:py-24 sm:px-6 lg:mx-auto flex lg:max-w-7xl lg:px-8 lg:py-32 justify-end">
        <div className="sm:pl-6 lg:pl-8 col-span-2 w-full sm:w-2/3  lg:w-1/2">
          <div className="sm:max-w-lg sm:ml-auto">
            {component.richtitle && (
              <RichText
                stringHtml={component.richtitle}
                option="sectionTitle"
              />
            )}
            <p className="mt-3 text-lg leading-6 text-gray-500">
              {component.richSubtitle && (
                <RichText
                  stringHtml={component.richSubtitle}
                  option="standardOptions"
                />
              )}
            </p>
            {addForm(component.form)}
          </div>
        </div>
      </div>
    </div>
  )
}
